import { Breadcrumb as DIGBreadcrumb } from "@dropbox/dig-components/breadcrumb";
import { Text } from "@dropbox/dig-components/typography";
import { Link } from "@mirage/mosaics/BaseProfilePage/Link";
import type { BasicUserInfo } from "@mirage/mosaics/UserProfilePage/types";
import { getUserProfilePageHref } from "@mirage/mosaics/UserProfilePage/utils";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";

// eslint-disable-next-line no-restricted-imports
import type { LinkProps as DIGBreadcrumbLinkProps } from "@dropbox/dig-components/dist/breadcrumb/types";
import type { LinkProps as RouterLinkProps } from "react-router-dom";

export type BreadcrumbLinkProps = Omit<DIGBreadcrumbLinkProps, "href"> &
  RouterLinkProps;

const breadcrumbLinkBuilder = (breadcrumbs: BreadcrumbLinkProps[]) =>
  breadcrumbs.map((breadcrumb, index) => (
    <DIGBreadcrumb.Link
      key={`user-profile-page-breadcrumb__${breadcrumb.id}`}
      isCurrentPath={!index}
      withLeftIcon={breadcrumb.withLeftIcon}
      withMenuItemIcon={breadcrumb.withMenuItemIcon}
      onClick={(e) => e.preventDefault()}
    >
      <Link
        {...breadcrumb}
        to={breadcrumb.to}
        hasNoUnderline
        showUnderlineOnHover
        monochromatic
      >
        {index == breadcrumbs.length - 1 ? (
          <Text size="small">{breadcrumb.children}</Text>
        ) : (
          breadcrumb.children
        )}
      </Link>
    </DIGBreadcrumb.Link>
  ));

export const PeopleBreadcrumbs = ({
  employees,
}: {
  employees: BasicUserInfo[];
}) => {
  const isMobileSize = useIsMobileSize();
  if (employees.length === 0 || isMobileSize) return null;

  const peopleBreadcrumbs: BreadcrumbLinkProps[] = employees.map(
    (employee) => ({
      id: employee.account_id,
      children: employee.name,
      to: getUserProfilePageHref(employee.display_handle),
    }),
  );

  return (
    <DIGBreadcrumb
      linksDisplayed={2}
      typography="text"
      size="small"
      isRootOverflow={true}
    >
      {breadcrumbLinkBuilder(peopleBreadcrumbs)}
    </DIGBreadcrumb>
  );
};
